export const tutorialImages = [
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/f2a80524-59bd-433c-8e17-2f686c0b3929_compressed_ChatGPT-Image-12-ago-2026-03_56_32-p.m..webp',
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/80ffa10f-bfae-43bf-82b2-80a90292a50c_compressed_ChatGPT-Image-12-ago-2026-03_56_27-p.m.-4.webp',
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/b5070303-5b1e-4722-9771-774eb492f6b5_compressed_ChatGPT-Image-12-ago-2026-03_56_26-p.m.-1.webp',
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/e6c3a729-0341-4879-a586-4307352bccf2_compressed_ChatGPT-Image-12-ago-2026-03_56_27-p.m.-3.webp',
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/3891e34f-1318-48a4-81e7-3f8dd4d8b1b4_compressed_ChatGPT-Image-12-ago-2026-03_56_27-p.m.-5.webp',
  'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/7f8f7d2e-c646-4c6e-a93f-a874bf34d318_compressed_ChatGPT-Image-12-ago-2026-03_56_26-p.m.-2.webp',
];

export const mercedesImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/9e064e6b-43da-4599-9aa5-450b1ce5ffb4_compressed_ChatGPT-Image-1-ago-2026-07_00_00-p.m.-2.webp';

export const cambiarTutorials = [
  {
    id: 1,
    number: '01',
    title: '5 Señales de Sueño que Toda Mamá Debe Conocer',
    description:
      'Aprendé a reconocer algunas de las señales que aparecen antes de que tu bebé llegue demasiado cansado al momento de dormir. Entenderlas puede ayudarte a anticiparte y empezar a organizar el descanso de una manera más tranquila.',
    duration: '10 min',
    route: '/guia-senales-sueno',
    image: tutorialImages[0],
  },
  {
    id: 2,
    number: '02',
    title: 'Rutina de Relajación de 10 Minutos',
    description:
      'Una rutina sencilla para bajar progresivamente el ritmo, reducir estímulos y preparar el momento del descanso. Pequeños cambios pueden ayudar a transformar la transición hacia el sueño en un momento más predecible y tranquilo.',
    duration: '12 min',
    route: '/rutina-relajacion',
    image: tutorialImages[1],
  },
  {
    id: 3,
    number: '03',
    title: 'Yoga para Dormir: Secuencia Nocturna',
    description:
      'Una secuencia suave para incorporar movimiento, respiración y calma durante los momentos previos al descanso. Una herramienta para transformar esos minutos en un pequeño ritual de conexión.',
    duration: '6 min',
    route: '/yoga-dormir-secuencia-nocturna',
    image: tutorialImages[2],
  },
  {
    id: 4,
    number: '04',
    title: 'Cómo Crear el Ambiente Ideal de Sueño',
    description:
      'Luz, temperatura, estímulos, sonidos y pequeñas características del entorno pueden influir en el momento de descansar. En este tutorial vas a aprender qué observar y qué pequeños ajustes podés probar en casa.',
    duration: '15 min',
    route: '/ambiente-ideal-sueno',
    image: tutorialImages[3],
  },
  {
    id: 5,
    number: '05',
    title: 'Cómo Manejar las Regresiones del Sueño',
    description:
      'De repente tu bebé dormía de una manera y todo cambió: más despertares, más dificultad para dormirse, más necesidad de contacto. En este tutorial vas a entender mejor por qué pueden aparecer estos períodos y cómo acompañarlos sin sentir que todo lo que habías construido desapareció.',
    duration: '8 min',
    route: '/regresiones-sueno',
    image: tutorialImages[4],
  },
  {
    id: 6,
    number: '06',
    title: 'Meditación para Mamás Cansadas',
    description:
      'Este contenido no es para tu bebé. Es para vos. Un pequeño espacio para respirar, bajar la tensión y recuperar algo de calma en esos días en los que sentís que ya no tenés energía. Porque acompañar también significa aprender a cuidarte mientras cuidás.',
    duration: '',
    route: '/meditacion-mamas-cansadas',
    image: tutorialImages[5],
  },
];

export const cambiarSignals = [
  'Cada noche se está convirtiendo en una batalla.',
  'Tu bebé se despierta constantemente y no entendés por qué.',
  'Sentís que probaste muchas cosas y ninguna termina de funcionar.',
  'Dependés de una única forma de dormirlo y ya no podés sostenerla.',
  'Las siestas se volvieron impredecibles.',
  'Te cuesta reconocer cuándo tu bebé realmente tiene sueño.',
  'Las regresiones del sueño desordenan completamente las rutinas.',
  'Sentís culpa cuando intentás modificar algún hábito.',
  'Recibís tantos consejos diferentes que ya no sabés a quién escuchar.',
  'El cansancio está afectando tu paciencia, tu descanso o tu vida cotidiana.',
  'Querés acompañar el sueño de tu bebé sin convertir cada noche en una lucha.',
  'Querés volver a confiar en tus propias decisiones como mamá.',
];

export const cambiarGuides = [
  {
    id: 1,
    situation: 'Si no reconocés cuándo tu bebé tiene sueño',
    suggestion: 'Empezá por 5 Señales de Sueño que Toda Mamá Debe Conocer.',
    route: '/guia-senales-sueno',
  },
  {
    id: 2,
    situation: 'Si el momento de dormir se volvió caótico',
    suggestion: 'Probá Rutina de Relajación de 10 Minutos.',
    route: '/rutina-relajacion',
  },
  {
    id: 3,
    situation: 'Si buscás incorporar un ritual más tranquilo',
    suggestion: 'Empezá por Yoga para Dormir: Secuencia Nocturna.',
    route: '/yoga-dormir-secuencia-nocturna',
  },
  {
    id: 4,
    situation: 'Si sospechás que el entorno está interfiriendo',
    suggestion: 'Mirá Cómo Crear el Ambiente Ideal de Sueño.',
    route: '/ambiente-ideal-sueno',
  },
  {
    id: 5,
    situation: 'Si tu bebé cambió repentinamente su manera de dormir',
    suggestion: 'Empezá por Cómo Manejar las Regresiones del Sueño.',
    route: '/regresiones-sueno',
  },
  {
    id: 6,
    situation: 'Y si sentís que la que necesita unos minutos de calma sos vos',
    suggestion: 'Elegí Meditación para Mamás Cansadas.',
    route: '/meditacion-mamas-cansadas',
  },
];